import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { SearchBar } from '@liepin/react-search4c-pc';
import styled from './index._less';
import ImgHomeQrcodeCom from '../../images/home-qrcode-com.png';

const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent); // 兼容Safari浏览器悬停瞬间变形问题

const HomeSearchBar = () => {

  const [fixedSearchBar, setFixedSearchBar] = useState(false); // 只用于控制悬停的样式，悬停外层sticky控制

  useEffect(() => {
    const $homeSearchBarTop = document.querySelector('#home-search-bar-top');
    const onScroll = () => {
      const offsetTop =  $homeSearchBarTop?.offsetTop || 0;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      setFixedSearchBar(scrollTop >= offsetTop + 10); // 搜索框上面留白悬停时少了10px，避免突然塌陷的抖动
    }
    window.addEventListener('scroll', onScroll, false);
    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  return (
    <>
      <div
        style={ isSafari ? {transition: 'all 1ms'} : {}}
        className={ classnames('home-search-bar-container', {'home-search-bar-container-fixed': fixedSearchBar }) }
      >
        <div className="common-page-container">
            <SearchBar
              simple={ fixedSearchBar }
              showHot={ !fixedSearchBar }
              qrcode={ ImgHomeQrcodeCom }
            />
        </div>
      </div>
      <style jsx>{ styled }</style>
    </>
  )
}

export default HomeSearchBar;
